import React from 'react';
import CircularProgress from '@material-ui/core/CircularProgress';

const Loading = () => (
    <CircularProgress/>
);

export default Loading;
